import { ModalType } from '../../types/generated-types';
import { assertUnreachable } from '../../utils/compiler-utils';

export const getModalButtonText = (modalType: ModalType): string => {
    switch (modalType) {
        case ModalType.Normaltap:
            return 'Hvordan finner jeg mitt normaltap?';
        default:
            return assertUnreachable(modalType);
    }
};
